import {HistoryStep} from "./historyStep";
import {HistoryController, IHistoryStepWithSelObs} from "./historyController";
import {SelectableObject} from "../selectableObjects";
import {CONSTANTS} from "../meta_data";
import {EventVerteiler} from "../../global/eventVerteiler";
import {SELOBEVENTNAMES} from "../../global/GlobalEventnames";

/**
 * Hier werden Veränderungen von SelObs gespeichert.
 * Dazu wird das SelOb gespeichert wenn die Interaktion beginnt. Dann wird beim Beenden festgestellt, zu welchem Objekt das aktuelle geworden ist.
 * Beim Undo wird dann das endstateObjekt gelöscht und das alte eingefügt.
 * @class
 * @extends HistoryStep
 * @param {HistoryController} historyController
 * @param {{selOb, type}} parameters
 * TODO eigentlich handelt es sich im Prinzip hier nur um eine Zusammenfassung eines insert und eines delete Steps mit ein bisschen Verwaltung dazu...
 */
export class HistoryStepSelObChanged extends HistoryStep implements IHistoryStepWithSelObs {
    private readonly selOb: SelectableObject;
    private readonly zOrderOnStart;
    private readonly selObClonesOnStart;
    private endStateSelOb;
    private cloneIdsOnInteractionEnd;
    private zOrderOnInteractionEnd;

    constructor(historyController: HistoryController, parameters) {
        if (typeof (parameters.type) !== "string") {
            parameters.type = "selObChanged";
        }
        super(historyController, parameters);

        this.selOb = (parameters.selOb as SelectableObject).clone(true);
        this.zOrderOnStart = this.controller.selObController.getZIndexOfSelOb(parameters.selOb.id);
        this.selObClonesOnStart = this.selOb.cloneIds.slice();

        this.endStateSelOb = null;
        this.cloneIdsOnInteractionEnd = null;
        this.zOrderOnInteractionEnd = null;
    }

    undo() {
        const $this = this;
        this.controller.restoreCameraAndModelSettings(this.viewDetails);
        this.busy();
        setTimeout(function () {
            $this.insertAndDeleteSelObs("undo");
        }, CONSTANTS.UNDO_DELAY);

    }

    redo() {
        const $this = this;
        this.controller.restoreCameraAndModelSettings(this.viewDetails);
        this.busy();
        setTimeout(function () {
            $this.insertAndDeleteSelObs("redo");
        }, CONSTANTS.UNDO_DELAY);
    }

    insertAndDeleteSelObs(direction) {
        let selObToDelete, selObToInsert, cloneIdsToReplace, zIndexToInsert;
        const $this = this;

        if (direction === "undo") {
            selObToDelete = this.endStateSelOb;
            selObToInsert = this.selOb.clone(true);
            cloneIdsToReplace = this.selObClonesOnStart;
            zIndexToInsert = this.zOrderOnStart;
        } else {
            selObToDelete = this.selOb;
            selObToInsert = this.endStateSelOb.clone(true);
            cloneIdsToReplace = this.cloneIdsOnInteractionEnd;
            zIndexToInsert = this.zOrderOnInteractionEnd;
        }

        this.controller.selObController.deleteSelOb(selObToDelete.id);
        this.controller.selObController.insertSelObFromStorage(selObToInsert, zIndexToInsert);
        this.createCloneCreationWaiter(
            selObToInsert.id,
            cloneIdsToReplace.length,
            function (newCloneIds) {
                $this.controller.replaceIds(cloneIdsToReplace, newCloneIds);
            }
        );
        EventVerteiler.broadcast(SELOBEVENTNAMES.SELECTION_REQUEST, selObToInsert.id);
        this.noLongerBusy();
    }

    setEndStateSelOb(id) {
        const selOb = this.controller.getSelOb(id);
        if (selOb === null) {
            return;
        }
        this.endStateSelOb = selOb.clone(true);
        this.cloneIdsOnInteractionEnd = selOb.cloneIds.slice();
        this.zOrderOnInteractionEnd = this.controller.selObController.getZIndexOfSelOb(selOb.id);
    }

    replaceId(origId, newId) {
        const selObs = [this.selOb], arrays = [this.selObClonesOnStart];

        if (this.endStateSelOb !== null) {
            selObs.push(this.endStateSelOb);
            arrays.push(this.cloneIdsOnInteractionEnd);
        }
        for (let i = 0, lenI = selObs.length; i < lenI; i++) {
            if (selObs[i].id === origId) {
                selObs[i].id = newId;
            }
            HistoryStep.replaceValueInArray(origId, newId, arrays[i]);
        }
    }

    cloneWasDeleted(origId, cloneId) {
        let waiter;
        if (origId === this.endStateSelOb.id) {
            HistoryStep.deleteValueFromArray(cloneId, this.endStateSelOb.cloneIds);
            HistoryStep.deleteValueFromArray(cloneId, this.cloneIdsOnInteractionEnd);
            if (typeof (this.cloneCreationWaiter[origId]) !== "undefined") {
                waiter = this.cloneCreationWaiter[origId];
                waiter.numberToWaitFor--;
                this.checkAfterCloneCreation(origId);
            }
        }
    }
}